import { render } from "./AdminNotesModal.vue?vue&type=template&id=616e4cd9"
import script from "./AdminNotesModal.vue?vue&type=script&lang=js"
export * from "./AdminNotesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__